export const DEFAULT_PAGE_SIZE = 21;
export const JUMP_NEXT_COUNT = 3;
export const JUMP_PREV_COUNT = 3;
export const MOBILE_SCREEN_WIDTH = 720;

export const SLIDER_MOBILE_VERTICAL_COUNT = 2.8;
export const SLIDER_MOBILE_HORIZONTAL_COUNT = 1.5;
export const SLIDER_DESKTOP_VERTICAL_COUNT = 3.5;
export const SLIDER_DESKTOP_HORIZONTAL_COUNT = 1.5;
export const SLIDER_SINGLE_ITEM_COUNT = 1;

export const DEFAULT_SWIPER_INSTANCE_WIDTH = 1000;
export const SHORT_SPACE_24 = 24;
export const SHORT_SPACE_12 = 12;
export const LONG_SPACE_32 = 32;
